module.exports = __webpack_public_path__ + "static/media/Album 2.e46437b1.png";